export var CommentEditType;
(function (CommentEditType) {
    CommentEditType["DELETE"] = "delete";
    CommentEditType["MODERATE"] = "moderate";
    CommentEditType["UPDATE"] = "update";
})(CommentEditType || (CommentEditType = {}));
export var VoteTypeEdit;
(function (VoteTypeEdit) {
    VoteTypeEdit["MODERATE"] = "moderate";
    VoteTypeEdit["UPDATE"] = "update";
})(VoteTypeEdit || (VoteTypeEdit = {}));
export var RecognitionTypeEdit;
(function (RecognitionTypeEdit) {
    RecognitionTypeEdit["MODERATE"] = "moderate";
    RecognitionTypeEdit["UPDATE"] = "update";
    RecognitionTypeEdit["ARCHIVE"] = "archive";
})(RecognitionTypeEdit || (RecognitionTypeEdit = {}));
